import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges, OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {BacklogService} from '@components/backlog/backlog.service';
import {ToastrService} from 'ngx-toastr';
import {BackendResponse} from '@app/interfaces/backendResponse';
import {Task} from '@app/interfaces/task';
import {ConstantsService} from '@app/services/constants/constants.service';
import {CommentsService} from '@app/services/comments/comments.service';
import {UploadService} from '@common-components/file-upload/upload.service';
import {Globals} from '@app/services/globals.service';
import {DatePipe} from '@angular/common';
import {HelperService} from '@app/services/helper/helper.service';
import {Sprint} from '@app/interfaces/sprint';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-backlog-task-preview',
    templateUrl: './backlog-task-preview.component.html',
    styleUrls: ['./backlog-task-preview.component.css'],
    providers: [BacklogService]
})
export class BacklogTaskPreviewComponent implements OnInit, OnChanges, OnDestroy {
    id: string = '';
    task: Task;
    loader: boolean = false;

    createdByText = '';

    commentText = '';
    commentAttachments = [];
    comments = [];

    commentUploadedFiles = [];
    createdAtText = '';

    creatorData = {};
    validators = [];
    assigned = [];
    statusClass = '';
    searchText = '';
    sprints: Sprint[] = [];


    @Input() taskId: string;
    @Input() sort: string;
    @Output() closedPreview = new EventEmitter<boolean>();
    @Output() sprintChanged = new EventEmitter<string>();
    @ViewChild('fileUpload') fileUpload: ElementRef;
    loggedInUser = {};
    newSprintSubscription: Subscription;


    constructor(private backlogService: BacklogService,
                private toastrService: ToastrService,
                private constantsService: ConstantsService,
                private commentsService: CommentsService,
                private uploadService: UploadService,
                private globals: Globals,
                private datePipe: DatePipe,
                private helperService: HelperService
    ) {
    }

    async ngOnInit() {

        this.newSprintSubscription = this.backlogService.sprintCreated.subscribe(data => {
            if (data === true) {
                this.getActiveSprints();
                this.backlogService.sprintCreated.next(false);
            }
        });

        this.searchText = '';
        this.loggedInUser = this.constantsService.userData;
        this.loader = true;
        this.id = this.taskId;
        await this.getTaskData(this.id);
        this.getActiveSprints();

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.taskId.previousValue != undefined) {
            this.ngOnInit();
        }
    }

    ngOnDestroy(): void {
        this.newSprintSubscription.unsubscribe();
    }


    getTaskData(id) {
        this.assigned = [];
        this.validators = [];
        this.id = id;
        return new Promise((resolve, reject) => {
            try {
                this.backlogService.getTaskData(id, this.sort).subscribe(async (response: BackendResponse) => {
                    if (response.type === 'success') {
                        this.task = response.data;
                        this.loader = false;
                        this.createdByText = 'Kreairao/la Dejana Spasojevic, 30.09.2021 11:11h';
                        this.comments = this.task.task_comments;
                        await this.transformCreatedAtDateHandler(this.task.created_at);
                        const creator = this.globals.allAppUsers.find(item => item.id === this.task.created_by);
                        this.createdByText = `Kreirao/la ${creator['first_name']}  ${creator['last_name']}, ${this.createdAtText}`;
                        this.creatorData = this.helperService.getDataForUserId(this.task.created_by);
                        this.task.validator_id.forEach(item => {
                            const data = this.helperService.getDataForUserId(item);
                            this.validators.push(data);
                        });
                        this.task.assigned.forEach(item => {
                            const data = this.helperService.getDataForUserId(item);
                            this.assigned.push(data);
                        });
                        if (this.task.sprint_id !== null) {
                            this.searchText = this.task?.sprint?.name;
                        }
                        await this.getStatusClass(this.task.status);
                        this.task.status = this.helperService.tranformStatusToName(this.task.status);

                        resolve();

                    } else {
                        this.toastrService.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
                        throw new Error('Došlo je do greške prilikom izvlačenja podataka za zadatak.' +
                            ' Molimo Vas obratite se korisničkoj podršci.');
                    }
                });
            } catch (e) {
                reject(e);
            }
        });

    }

    getStatusClass(status) {
        return new Promise((resolve, reject) => {
            switch (status) {
                case 'todo':
                    this.statusClass = 'status-button-todo';
                    break;

                case 'inprogress':
                    this.statusClass = 'status-button-inprogress';
                    break;

                case 'ddone' || 'validated':
                    this.statusClass = 'status-button-done';
                    break;

                case 'canceled' || 'deleted':
                    this.statusClass = 'status-button-canceled';
                    break;

                case 'postponed':
                    this.statusClass = 'status-button-postponed';
                    break;

            }
            if (this.statusClass !== '') {
                resolve();
            }

        });


    }

    transformCreatedAtDateHandler(date) {
        try {
            let today = new Date();
            let yesterday = new Date();

            let createdAt = new Date(date);
            let time = createdAt.getHours() + ':' + ("0" + createdAt.getMinutes()).slice(-2);


            createdAt.setHours(0, 0, 0);

            yesterday.setDate(today.getDate() - 1);
            yesterday.setHours(0, 0, 0);


            if (createdAt.toDateString() == yesterday.toDateString()) {
                this.createdAtText = 'juče u ' + ' ' + time + 'h.';
            } else {
                this.createdAtText = this.datePipe.transform(createdAt, 'dd.MM.yyyy') + ' ' + time + 'h';
            }
        } catch (e) {

        }

    }


    addComment() {
        if (this.commentText === '' && this.commentAttachments.length === 0) return;
        this.commentsService.addComment(this.taskId, this.commentText, this.task.sort, this.commentAttachments)
            .subscribe((response: BackendResponse) => {
                if (response.type === 'success') {
                    this.commentText = '';
                    this.commentsService.getComments(this.id).subscribe((response) => {
                        this.comments = response;
                        this.commentAttachments = [];

                    });
                } else {
                    throw new Error('Backlog Adding Comments');
                }
            }), error => {
            this.toastrService.error('Došlo je do greške prilikom dodavanja komentara.' +
                ' Molimo Vas obratite se korisničkoj podršci.');
        };
    }

    onFileUploadClick() {
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.click();
    }

    async upload(event) {
        this.commentUploadedFiles = [];
        for (let i = 0; i < event.target.files.length; i++) {
            this.commentUploadedFiles.push(event.target.files[i]);
        }
        await this.uploadAndProgress(event.target.files);
    }

    async uploadAndProgress(files: File[]) {
        const formData = new FormData();

        for (let i = 0; i < this.commentUploadedFiles.length; i++) {
            formData.append("file[]", this.commentUploadedFiles[i]);
        }

        let response = await this.uploadService.upload(formData);
        if (response['type'] === 'success') {
            this.commentAttachments = this.commentAttachments.concat(response['data']);
        } else {
            this.toastrService.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            return;
        }
    }

    deleteFileHandler(event) {
        this.commentAttachments = this.commentAttachments.filter(item => item.name !== event.name);
    }

    onClose() {
        this.closedPreview.emit(true);
        this.searchText = '';
    }

    setSprint(sprintId) {
        if (sprintId === this.task.sprint_id) {
            return;
        }
        this.backlogService.setSprint(this.taskId, sprintId).subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.sprintChanged.emit('SPRINT_CHANGED');
                this.task.sprint_id = sprintId;

            } else {
                this.searchText = '';
                this.toastrService.error('Došlo je do greške prilikom odabira sprinta. Molimo Vas obratite se korisničkoj podršci.');

            }
        });
    }

    removeSprint() {
        this.backlogService.removeSprint(this.taskId).subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.searchText = '';
                this.sprintChanged.emit('SPRINT_CHANGED');
            } else {
                this.toastrService.error('Došlo je do greške prilikom odabira sprinta. Molimo Vas obratite se korisničkoj podršci.');
            }
        });

    }

    getActiveSprints() {
        this.sprints = [];
        this.backlogService.getActiveAndInactiveSprints(this.task.project_id).subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.sprints = response.data;
            } else {
                this.toastrService.error('Došlo je do greške prilikom izvlačenja sprintova.');
            }
        });
    }


}
